import * as React from 'react';
import { useAuth, User } from '../Auth';

const UserContext = React.createContext<User | null>(null);

const UserProvider = ({ children }: React.PropsWithChildren) => {
	const { state } = useAuth();
	const user = state.userToken ? state.user || null : null;

	return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

const useUser = () => React.useContext(UserContext);

export { UserProvider, useUser };
